import { render, staticRenderFns } from "./ProductStickyBasket.vue?vue&type=template&id=73aa25a3"
import script from "./ProductStickyBasket.vue?vue&type=script&lang=js"
export * from "./ProductStickyBasket.vue?vue&type=script&lang=js"
import style0 from "./ProductStickyBasket.vue?vue&type=style&index=0&id=73aa25a3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports